module.exports = __webpack_public_path__ + "img/194.9952d677.jpg";